export const APP_VERSION = '3.0.3-alpha.1';
export const BUILD_TIMESTAMP = '2026-07-23T08:16:25Z';
export const ENVIRONMENT = 'alpha' as 'development' | 'alpha' | 'staging' | 'production';
